import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { changeMaxHouseYear, changeMinHouseYear } from '../../../../../../state/advanced/house_year';
import { HouseYear as HouseYearComponent, IHouseYearProps } from './houseYear';

type THouseYearStoreProps = Pick<IHouseYearProps, 'minYear' | 'maxYear'>;
type THouseYearDispatchProps = Pick<IHouseYearProps, 'onMinYearChanged' | 'onMaxYearChanged'>;

function mapStateToProps(state: IAppState): THouseYearStoreProps {
  const { jsonQuery } = state.filters;

  return {
    minYear: jsonQuery.house_year && jsonQuery.house_year.value.gte,
    maxYear: jsonQuery.house_year && jsonQuery.house_year.value.lte,
  };
}

function mapDispatchToProps(dispatch: Dispatch): THouseYearDispatchProps {
  return {
    onMinYearChanged: (value: number | undefined) => {
      dispatch(changeMinHouseYear(value));
    },
    onMaxYearChanged: (value: number | undefined) => {
      dispatch(changeMaxHouseYear(value));
    },
  };
}

export const HouseYear = connect(mapStateToProps, mapDispatchToProps)(HouseYearComponent);
